export default __webpack_public_path__ + "static/media/AlienBlaster.6deedeac.mp3";